import React from 'react';
import { Helmet } from 'react-helmet-async';

const ParentCampusReport = () => {
  return (
    <>
      <Helmet>
        <script
          type="module"
          src={`${process.env.HYBRID_REMOTE_ENTRY}?cache=${process.env.BUILD_CACHE}`}
        />
      </Helmet>
      <div id="parent_report_container" className="w-full"></div>
    </>
  );
};

export default ParentCampusReport;
